<template>
<div>
    <car-headerbar :title="'常用题型'" :isCustomLeft="isCustomLeft"/>
    <me-grid>
        <me-grid-item
            v-for="(item, index) in topics"
            :key="index"
            :icon="item.icon"
            @click="turnTo(item.type)"
            :text="item.text"
        />
        <me-grid-item/>
    </me-grid>
</div>
</template>
<script>
import { Questionnaire } from '@/network'
import { mixin } from '@/mixins'
import { off as offStatus } from '@/util/status-util'
import browser from '@/util/browser'
const radioIcon = require('../images/icon/radio_icon.png')
const checkboxIcon = require('../images/icon/checkbox_icon.png')
const fillIcon = require('../images/icon/fill_icon.png')
const pragraphIcon = require('../images/icon/pragraph_icon.png')
const rateIcon = require('../images/icon/rate_icon.png')
const npsIcon = require('../images/icon/nps_icon.png')
const matrixRateIcon = require('../images/icon/matrix_rate_icon.png')

export default {
    data() {
        return {
            typeList: [],
            topics: [
                {
                    icon: radioIcon,
                    text: '单选',
                    type: 'radio'
                },
                {
                    icon: checkboxIcon,
                    text: '多选',
                    type: 'checkbox'
                },
                {
                    icon: fillIcon,
                    text: '填空',
                    type: 'textarea'
                },
                {
                    icon: pragraphIcon,
                    text: '段落说明',
                    type: 'paragraph'
                },
                {
                    icon: rateIcon,
                    text: '评分',
                    type: 'rate'
                },
                {
                    icon: npsIcon,
                    text: 'NPS量表',
                    type: 'nps'
                },
                {
                    icon: matrixRateIcon,
                    text: '矩阵评分',
                    type: 'matrix-rate'
                },
            ],
            isCustomLeft: false,
        }
    },
    mixins: [mixin],
    created() {
        offStatus('loading')
        const { guaguaApp } = browser
        if (guaguaApp) {
            this.isCustomLeft = guaguaApp
        }
    },
    methods: {
        getTopicType() {
            Questionnaire.getTopicType({
                tid: this.tid,
                type: 'question',
            }).then((res) => {
                if (res.data.code == 'S00000') {
                    this.typeList = res.data.data
                }
            }).catch((error) => {
                console.error(error)
            })
        },
        turnTo(type) {
            this.$store.commit('updateShowTopicList', null)
            this.$store.commit('updateShowJson', null)
            this.$router.replace({
                name: 'topic',
                params: {
                    type: type,
                    pageId: this.$route.params.pageId,
                },
            })
        },
    },
}
</script>
<style lang="scss" scoped>
    .item-text{
        margin-top: 10px;
    }
    ::v-deep .me-icon{
        font-size: 27px;
    }
</style>
